"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewStatusColumnFilter = void 0;
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const types_1 = require("evolution-common/lib/services/reviews/types");
/**
 * Dropdown filtering the interview list on the interview-level review status.
 *
 * @param param0 description of the filtered column
 * @returns
 */
const ReviewStatusColumnFilter = ({ column: { filterValue, setFilter } }) => {
    const { t } = (0, react_i18next_1.useTranslation)('admin');
    return (react_1.default.createElement("div", { style: { display: 'flex', margin: '2px 0' } },
        react_1.default.createElement("label", { htmlFor: 'surveyValidation-filter-reviewStatus' }, t('admin:reviewStatusFilters:title')),
        react_1.default.createElement("select", { id: 'surveyValidation-filter-reviewStatus', value: filterValue, onChange: (e) => {
                setFilter(e.target.value || undefined);
            } }, types_1.interviewListStatusFilterValues.map((key) => (react_1.default.createElement("option", { key: `reviewStatusSelection_${key}`, value: key }, t(`admin:reviewStatusFilters:${key}`)))))));
};
exports.ReviewStatusColumnFilter = ReviewStatusColumnFilter;
//# sourceMappingURL=ReviewStatusColumnFilter.js.map